"use strict";

exports.__esModule = true;
exports.UserAction = UserAction;
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../Core/Translator");
var _TranslateLabel = require("./TranslateLabel");
var _userActionsContext = require("./userActionsContext");
var _excluded = ["name", "label"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function UserAction(_ref) {
  var name = _ref.name,
    label = _ref.label,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var userActions = _react["default"].useContext(_userActionsContext.UserActionsContext);
  var userAction = userActions.find(function (action) {
    return action.name === name;
  });
  var Element = userAction.components.Element;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var labelString = (0, _TranslateLabel.translateLabel)(label, translate);
  return /*#__PURE__*/_react["default"].createElement(Element, _extends({}, extra, {
    label: labelString
  }));
}